export const jobs = [
  {
    id: 1,
    title: "Senior Full Stack Developer",
    department: "Engineering",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "3 - 5 years",
    description:
      "Join our growing team of innovators, designers, and engineers to create scalable, high-quality digital products that make a real difference. At WebBocket, you'll work with modern technologies, embrace continuous learning, collaborate across talented teams, and build solutions that drive success for clients around the world.",
    skills: ["React", "Node.js", "MongoDB", "HTML", "CSS", "JavaScript", "Git"],

    overview:
      "Web_Bocket is looking for a passionate Senior Full Stack Developer to join our Engineering team. In this role, you'll design, develop, and maintain scalable web applications using modern frontend and backend technologies. You'll collaborate with designers, project managers, and fellow developers to build high-performance digital products that deliver exceptional user experiences while maintaining clean, maintainable, and secure code.",

    responsibilities: [
      "Develop scalable and high-performance web applications using React.js, Node.js, Express.js, and MongoDB.",
      "Build responsive, user-friendly interfaces following modern UI/UX best practices.",
      "Design, develop, and integrate secure RESTful APIs with third-party services.",
      "Collaborate with cross-functional teams to deliver high-quality software solutions on time.",
      "Optimize application performance, maintain code quality, and troubleshoot technical issues.",
      "Participate in code reviews, sprint planning, and agile development processes.",
    ],

    requirements: [
      "3–5 years of professional experience in Full Stack Web Development.",
      "Strong proficiency in React.js, Node.js, Express.js, MongoDB, JavaScript, HTML5, and CSS3.",
      "Hands-on experience with REST APIs, third-party integrations, and Git version control.",
      "Good understanding of authentication, authorization, and web security best practices.",
      "Strong analytical, debugging, and problem-solving skills with attention to detail.",
      "Excellent communication, teamwork, and the ability to work effectively in an agile environment.",
    ],

    benefits: [
      "Competitive salary with performance-based growth opportunities.",
      "Collaborative and innovation-driven work culture.",
      "Exposure to diverse international and enterprise-level projects.",
      "Continuous learning through mentorship and technical knowledge sharing.",
      "Career advancement opportunities based on performance and leadership.",
      "Flexible and supportive working environment.",
      "Modern development tools and technologies.",
      "Recognition programs celebrating individual and team achievements.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our recruitment team carefully reviews your application, experience, and technical background.",
      },
      {
        title: "Technical Assessment",
        description:
          "Qualified candidates complete a technical discussion or coding assessment to evaluate problem-solving abilities.",
      },
      {
        title: "Final Interview",
        description:
          "Meet with our technical leadership to discuss your expertise, communication skills, and cultural fit.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Selected candidates receive an official offer followed by a structured onboarding experience.",
      },
    ],
  },

  {
    id: 2,
    title: "UI/UX Designer",
    department: "Design",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "2 - 4 years",
    description:
      "Create exceptional user experiences by designing modern, intuitive, and visually engaging interfaces for a wide range of digital products. At WebBocket, you'll collaborate with talented developers, product strategists, and creative professionals to transform ideas into impactful solutions while continuously growing your design expertise in a fast-paced, innovation-driven environment.",
    skills: ["Figma", "Adobe XD", "Prototyping", "Photoshop", "Illustrator"],

    overview:
      "Web_Bocket is looking for a creative UI/UX Designer who is passionate about crafting engaging digital experiences. You will collaborate closely with developers, project managers, and stakeholders to transform business requirements into intuitive, visually appealing, and user-centric interfaces. Your work will directly influence how users interact with our products across web and mobile platforms.",

    responsibilities: [
      "Design intuitive and user-friendly interfaces for web and mobile applications.",
      "Create wireframes, prototypes, and high-fidelity UI designs using Figma or Adobe XD.",
      "Collaborate with developers to ensure accurate implementation of designs.",
      "Conduct user research and usability testing to enhance user experience.",
      "Maintain consistent design systems, components, and brand guidelines.",
      "Stay updated with UI/UX trends, accessibility standards, and best design practices.",
    ],

    requirements: [
      "2–4 years of professional experience in UI/UX Design.",
      "Strong proficiency in Figma, Adobe XD, Photoshop, or Illustrator.",
      "Experience designing responsive web and mobile application interfaces.",
      "Solid understanding of user-centered design, typography, color theory, and layout principles.",
      "Ability to create wireframes, prototypes, and interactive design systems.",
      "Excellent communication, collaboration, and problem-solving skills.",
    ],

    benefits: [
      "Competitive salary with performance-based career growth.",
      "Creative and collaborative work environment.",
      "Opportunity to work on diverse national and international projects.",
      "Continuous learning through workshops, design reviews, and mentorship.",
      "Exposure to the latest design tools, trends, and technologies.",
      "Recognition and rewards for innovation and outstanding performance.",
      "Flexible and employee-friendly workplace culture.",
      "Clear career progression within the design team.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our hiring team reviews your portfolio, design experience, and creative background.",
      },
      {
        title: "Design Evaluation",
        description:
          "Shortlisted candidates participate in a design discussion or practical assessment to demonstrate problem-solving and design thinking.",
      },
      {
        title: "Final Interview",
        description:
          "Meet with our design leadership to discuss your design process, collaboration skills, and cultural fit.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Successful candidates receive an offer and begin a structured onboarding program with the design team.",
      },
    ],
  },

  {
    id: 3,
    title: "Mobile App Developer",
    department: "Engineering",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "2 - 3 years",
    description:
      "Create next-generation mobile applications for iOS and Android that deliver exceptional performance, intuitive user experiences, and scalable architecture. At WebBocket, you'll collaborate with talented designers, developers, and product teams to build innovative digital solutions while continuously enhancing your technical expertise in a collaborative and growth-oriented environment.",
    skills: ["React Native", "Flutter", "iOS", "Kotlin"],

    overview:
      "Web_Bocket is seeking a talented Mobile App Developer to build high-performance, user-friendly mobile applications for Android and iOS platforms. You'll collaborate with UI/UX designers, backend developers, and project managers to deliver scalable mobile solutions that provide seamless user experiences. If you're passionate about modern mobile technologies and building impactful applications, we'd love to have you on our team.",

    responsibilities: [
      "Develop high-quality mobile applications using React Native and Flutter.",
      "Build responsive, reusable, and scalable components for Android and iOS platforms.",
      "Integrate REST APIs, third-party SDKs, and external services into mobile apps.",
      "Collaborate with UI/UX designers to create engaging and user-friendly interfaces.",
      "Optimize application performance, security, and overall user experience.",
      "Debug issues, write clean code, and participate in code reviews and improvements.",
    ],

    requirements: [
      "2–3 years of professional experience in Mobile Application Development.",
      "Strong experience with React Native and/or Flutter frameworks.",
      "Understanding of Android and iOS development fundamentals.",
      "Experience working with REST APIs, JSON data, and mobile integrations.",
      "Knowledge of mobile architecture, state management, and Git workflows.",
      "Strong debugging, testing, problem-solving, and teamwork skills.",
    ],

    benefits: [
      "Competitive salary with performance-based incentives.",
      "Opportunity to work on innovative mobile products across multiple industries.",
      "Exposure to the latest mobile technologies and development practices.",
      "Continuous learning through mentorship, workshops, and technical sessions.",
      "Collaborative, innovation-driven work culture.",
      "Career growth opportunities within the engineering team.",
      "Modern development environment with advanced tools and resources.",
      "Recognition and rewards for exceptional performance.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our recruitment team evaluates your mobile development experience, technical expertise, and project portfolio.",
      },
      {
        title: "Technical Assessment",
        description:
          "Shortlisted candidates complete a technical interview or practical coding assessment focused on mobile application development.",
      },
      {
        title: "Final Interview",
        description:
          "Meet with our engineering leadership to discuss your technical knowledge, project experience, and cultural fit.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Successful candidates receive an offer followed by a structured onboarding process to help them integrate into the team.",
      },
    ],
  },

  {
    id: 4,
    title: "DevOps Engineer",
    department: "Infrastructure",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "3 - 6 years",
    description:
      "Drive the success of our cloud infrastructure by designing, managing, and optimizing scalable, secure, and highly available environments. At WebBocket, you'll collaborate with developers and product teams to automate deployment pipelines, improve CI/CD processes, enhance system reliability, and ensure the seamless delivery of innovative digital solutions using modern cloud technologies.",
    skills: ["AWS", "Docker", "Kubernetes", "CI/CD Pipeline", "Linux"],

    overview:
      "Web_Bocket is looking for an experienced DevOps Engineer to streamline our development lifecycle by building scalable cloud infrastructure, automating deployment pipelines, and ensuring maximum system reliability. You will work closely with developers, QA engineers, and project managers to maintain secure, highly available, and high-performing production environments while driving continuous improvement across our infrastructure.",

    responsibilities: [
      "Design, implement, and maintain scalable cloud infrastructure on AWS.",
      "Develop and manage CI/CD pipelines to automate software deployment.",
      "Containerize applications using Docker and orchestrate deployments with Kubernetes.",
      "Monitor infrastructure, applications, and production environments to ensure maximum uptime.",
      "Implement infrastructure as code and automate repetitive operational tasks.",
      "Optimize server performance, scalability, security, and disaster recovery strategies.",
      "Collaborate with development teams to improve deployment workflows and release processes.",
      "Troubleshoot infrastructure issues and proactively resolve production incidents.",
    ],

    requirements: [
      "3–6 years of professional experience in DevOps and Cloud Infrastructure.",
      "Strong experience with AWS services, Docker, Kubernetes, and containerization.",
      "Hands-on knowledge of CI/CD pipelines, automation tools, and deployment workflows.",
      "Understanding of Linux administration, shell scripting, networking, and security practices.",
      "Experience with monitoring, logging, and performance optimization tools.",
      "Strong troubleshooting, problem-solving, and infrastructure automation skills.",
    ],

    benefits: [
      "Competitive salary with performance-based growth opportunities.",
      "Work with modern cloud platforms and large-scale DevOps infrastructure.",
      "Continuous learning through certifications, mentorship, and technical training.",
      "Collaborative engineering environment focused on innovation and automation.",
      "Exposure to cloud-native technologies, scalable architectures, and enterprise solutions.",
      "Flexible work culture with modern tools and resources for professional growth.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our recruitment team reviews your infrastructure experience, cloud expertise, and technical background.",
      },
      {
        title: "Technical Assessment",
        description:
          "Shortlisted candidates participate in a technical discussion covering cloud infrastructure, automation, CI/CD, and system administration.",
      },
      {
        title: "Final Interview",
        description:
          "Meet with our engineering leadership to discuss your technical expertise, problem-solving approach, and collaboration skills.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Successful candidates receive an offer followed by a structured onboarding program to integrate into our engineering and infrastructure teams.",
      },
    ],
  },
  {
    id: 5,
    title: "Frontend Developer",
    department: "Engineering",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "1 - 3 years",
    description:
      "Develop next-generation web applications by creating responsive, interactive, and visually engaging user interfaces that provide exceptional user experiences. At WebBocket, you'll collaborate with talented designers, developers, and product teams to build scalable, high-performance applications while leveraging modern frontend technologies and following industry best practices to deliver impactful digital solutions.",
    skills: ["React", "Vue.js", "Tailwind CSS", "JavaScript", "HTML"],

    overview:
      "Web_Bocket is looking for a passionate Frontend Developer to create modern, responsive, and user-friendly web applications. You will work closely with UI/UX designers, backend developers, and project managers to transform creative designs into high-performance digital experiences while maintaining code quality, accessibility, and responsiveness across devices.",

    responsibilities: [
      "Develop responsive and interactive web interfaces using React.js and modern JavaScript.",
      "Convert UI/UX designs into reusable, scalable, and pixel-perfect components.",
      "Build clean, maintainable, and optimized frontend code following best practices.",
      "Integrate REST APIs and collaborate with backend teams for seamless functionality.",
      "Optimize applications for performance, accessibility, and cross-browser compatibility.",
      "Debug issues, participate in code reviews, and continuously improve user experience.",
    ],

    requirements: [
      "1–3 years of professional experience in frontend web development.",
      "Strong knowledge of HTML5, CSS3, JavaScript (ES6+), and React.js.",
      "Experience with Tailwind CSS or modern frontend styling frameworks.",
      "Understanding of component-based architecture and state management concepts.",
      "Knowledge of REST API integration, Git workflows, and responsive design principles.",
      "Strong problem-solving skills with the ability to learn and adapt to new technologies.",
    ],

    benefits: [
      "Competitive salary with annual performance reviews.",
      "Opportunity to work on modern, enterprise-level web applications.",
      "Continuous learning through mentorship and technical workshops.",
      "Collaborative and innovation-driven work environment.",
      "Exposure to the latest frontend technologies and best practices.",
      "Flexible work culture supporting work-life balance.",
      "Career growth opportunities within the engineering team.",
      "Recognition and rewards for outstanding performance and innovation.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our recruitment team evaluates your portfolio, technical skills, and frontend development experience.",
      },
      {
        title: "Technical Assessment",
        description:
          "Shortlisted candidates complete a frontend coding discussion focusing on React, JavaScript, responsive UI, and problem-solving.",
      },
      {
        title: "Final Interview",
        description:
          "Meet with our engineering leadership to discuss your technical expertise, communication skills, and career aspirations.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Selected candidates receive an offer followed by a structured onboarding program to ensure a smooth transition into our development team.",
      },
    ],
  },

  {
    id: 6,
    title: "Quality Assurance Engineer",
    department: "Quality",
    type: "Full Time",
    location: "Bhubaneswar, Odisha",
    experience: "2 - 4 years",
    description:
      "Play a key role in delivering high-quality digital solutions by ensuring the reliability, performance, and functionality of our software products through comprehensive testing and quality assurance practices. At WebBocket, you'll work closely with developers, designers, and product teams to identify issues, improve product quality, enhance user satisfaction, and contribute to the successful delivery of innovative software solutions.",
    skills: ["Selenium", "Jest", "Manual Testing", "Jira"],

    overview:
      "Web_Bocket is looking for a detail-oriented Quality Assurance Engineer to ensure the delivery of reliable, secure, and high-quality software solutions. You will collaborate with developers, designers, and project managers to identify defects, improve product quality, and deliver seamless user experiences through structured testing and continuous quality improvement.",

    responsibilities: [
      "Create and execute test plans, test cases, and quality validation processes.",
      "Perform manual and automated testing for web and mobile applications.",
      "Identify, document, and track software defects with clear reports.",
      "Collaborate with developers to analyze issues and ensure timely resolution.",
      "Conduct functional, regression, API, and performance testing before releases.",
      "Improve testing processes, documentation, and overall software quality standards.",
    ],

    requirements: [
      "2–4 years of professional experience in Software Quality Assurance or Testing.",
      "Strong understanding of manual testing methodologies and SDLC processes.",
      "Experience with Selenium or other automation testing frameworks.",
      "Knowledge of API testing, browser compatibility, and defect tracking tools.",
      "Understanding of Agile/Scrum workflows and software release cycles.",
      "Strong analytical skills, attention to detail, and communication abilities.",
    ],

    benefits: [
      "Competitive salary with performance-based growth opportunities.",
      "Work on enterprise-grade software products across multiple industries.",
      "Access to continuous learning, certifications, and technical workshops.",
      "Supportive, collaborative, and innovation-focused work culture.",
      "Modern development and testing tools.",
      "Flexible and employee-friendly work environment.",
      "Career advancement opportunities within QA and engineering teams.",
      "Recognition for quality improvements and process innovation.",
    ],

    hiringProcess: [
      {
        title: "Application Review",
        description:
          "Our recruitment team reviews your QA experience, testing expertise, and technical background.",
      },
      {
        title: "Technical Assessment",
        description:
          "Shortlisted candidates participate in a discussion covering manual testing, automation concepts, bug reporting, and quality assurance best practices.",
      },
      {
        title: "Final Interview",
        description:
          "Meet our engineering and QA leadership to evaluate technical expertise, communication skills, and cultural fit.",
      },
      {
        title: "Offer & Onboarding",
        description:
          "Successful candidates receive an offer followed by a structured onboarding program to integrate smoothly into our quality engineering team.",
      },
    ],
  },
];
